// src/Pages/Performers/PerformersPage.jsx
import React from "react";
import { useTheme } from "../../context/ThemeContext";
import HeroKenBurns from "../../components/HeroKenBurns/HeroKenBurns.jsx";
import PriceCalculatorWizard from "../../components/PriceCalculator/PriceCalculatorWizard";
import SetlistPlanner from "../../components/SetlistPlanner/SetlistPlanner";
// import RoudausDodgeSide from "../../components/RoudausDodgeGame/RoudausDodgeGame";
// import vanPng    from "../../assets/van.png";
// import singerPng from "../../assets/laulaja.png";
// import boxPng    from "../../assets/kaiutin.png";

// Taustakuvat (vaihda polut/format jos käytät .jpg tms.)
import backstageDark from "../../assets/backstage_dark.webp";
import backstageLight from "../../assets/backstage_light.webp";

const cx = (...c) => c.filter(Boolean).join(" ");

export default function PerformersPage() {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  // Teema-tyylit samaan henkeen kuin TietoaMeista
  const heroOverlay = isDark
    ? "from-black/60 via-black/30 to-black/60"
    : "from-white/40 via-white/25 to-white/30";

  const cardBg = isDark
    ? "bg-[#0b0b0f]/60 ring-white/10"
    : "bg-lemon/60 ring-white/40";

  const bodyText = isDark ? "text-white/85" : "text-black/80";
  const titleText = isDark ? "text-white" : "text-darkest";

  const heroImg = isDark ? backstageDark : backstageLight;

  return (
    <div className="min-h-screen w-full pt-20"> {/* tilaa headerille */}
      {/* HERO */}
      <header className="relative w-full h-[40vh] min-h-[320px] overflow-hidden">
        {/* Tausta: oma Backstage-kuva + rauhallinen kamera-ajo */}
        <HeroKenBurns
          image={heroImg}
          alt="Backstage: settilista, mikseri, kaapeleita ja valojen heijastuksia"
          focal={[80, 40]}
          base={1.30}
          duration={45}
          anchor="center"
          pan={{ x: 0.65, y: 0.20 }}
        />
        {/* Overlay lukemiseen */}
        <div className={cx("absolute inset-0 bg-gradient-to-b", heroOverlay)} />

        {/* Otsikko */}
        <div className="relative z-10 flex h-full items-center">
          <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
            <h1 className={cx(
              "font-customFont2 dark:text-shadow-lg text-center text-electric dark:text-primary text-5xl sm:text-6xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-tight",
              titleText
            )}>
              Backstage
            </h1>
          </div>
        </div>
      </header>

      {/* SISÄLTÖ */}
      <main className="relative w-full pb-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {/* Ingressi */}
          <section className={cx("mt-8 rounded-2xl backdrop-blur-md shadow-lg ring-1 p-6", cardBg)}>
            <p className={cx("dark:text-white/80 text-black/80 font-customFont1 text-lg xxxsm:text-xs xxsm:text-xs s24:text-xs xsm:text-xs sm:text-sm md:text-sm mdd:text-sm", bodyText)}>
              Backstage on meidän apupakki keikkailijalle: vähemmän säätöä, enemmän musaa.
              Teimme nämä työkalut, jotta omat hinnat olisivat reiluja ja kannattavia – ja
              settilistat syntyisivät ilman tusseja, kyyneleitä ja kiirettä.
            </p>

            <p className={cx("mt-3 dark:text-white/80 text-black/80 font-customFont1 text-lg xxxsm:text-xs xxsm:text-xs s24:text-xs xsm:text-xs sm:text-sm md:text-sm mdd:text-sm", bodyText)}>
              <span className="font-semibold">Hinnoittelulaskuri</span> (eli hinta-apuri) auttaa tekemään
              omista hinnoista eri alueilla kannattavia. Kerrot minne mennään ja kuinka pitkä veto on –
              apuri ehdottaa selkeän kokonaishinnan. Loistava, kun haluat sanoa “tämä on hinta” hyvällä
              omallatunnolla.
            </p>

            <p className={cx("mt-3 dark:text-white/80 text-black/80 font-customFont1 text-lg xxxsm:text-xs xxsm:text-xs s24:text-xs xsm:text-xs sm:text-sm md:text-sm mdd:text-sm", bodyText)}>
              <span className="font-semibold">Settilista-suunnittelija</span> korvaa tussin ja paperin, kun ne
              jäivät keittiön pöydälle. Kirjoita biisit, vedä & pudota ne paikoilleen ja näet keston yhdellä
              silmäyksellä. Valmis lista ulos hetkessä – tallenna siistiksi PDF:ksi tai jaa koko bändille
              vaikka WhatsAppissa.
            </p>
          </section>

          {/* Hinnoittelulaskuri */}
          <section className="mx-auto mt-8 max-w-6xl">
            <PriceCalculatorWizard />
          </section>

          {/* Settilista-suunnittelija */}
          <section className="mx-auto mt-8 max-w-6xl">
            <SetlistPlanner />
          </section>
            {/* <section className="mx-auto mt-8 max-w-6xl">
            <RoudausDodgeSide
            vanSrc={vanPng}
            singerSrc={singerPng}
            boxSrc={boxPng}
            targetDodges={50}
            />
            </section> */}
        </div>
      </main>
    </div>
  );
}
